// extracted by mini-css-extract-plugin
export default {"container":"wizardFooter_container__muVYG","footerText":"wizardFooter_footerText__LICGN","buttons":"wizardFooter_buttons__IK8au"};